import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ReplaySubject, combineLatest } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Selectors, Actions } from 'store/root-reducer';
import { BillableActionTypes } from 'store/actions/billable.actions';
import { environment } from 'environments/environment';
var VersionCardComponent = /** @class */ (function () {
    function VersionCardComponent(cdRef, store) {
        this.cdRef = cdRef;
        this.store = store;
        this.unsubscribe$ = new ReplaySubject(1);
        this.appSettings = {};
        this.searchEngines = [];
        this.userSubscriptions = [];
        this.error$ = this.store.select(Selectors.billable.getError);
    }
    VersionCardComponent.prototype.ngOnInit = function () {
        this.getLoadingStatus();
        this.appSettings.version = environment.VERSION;
        this.getBillableInfo();
    };
    VersionCardComponent.prototype.ngOnDestroy = function () {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    };
    /**
     * Get loading status from store
     * @method getLoadingStatus
     */
    VersionCardComponent.prototype.getLoadingStatus = function () {
        this.loading$ = this.store.select(Selectors.billable.getLoading)
            .pipe(takeUntil(this.unsubscribe$), map(function (billableLoading) {
            return billableLoading.includes(BillableActionTypes.LOAD_BILLABLE);
        }));
    };
    /**
     * Prepare string of inlined search providers names
     * @method prepareSearchProvidersString
     */
    VersionCardComponent.prototype.prepareSearchProvidersString = function (searchEngines) {
        return searchEngines.filter(function (value) { return value.display; })
            .map(function (value) { return value.serviceName; })
            .join(', ');
    };
    /**
     * Get subscription information from state
     * @method getBillableInfo
     */
    VersionCardComponent.prototype.getBillableInfo = function () {
        var _this = this;
        combineLatest([
            this.store.select(Selectors.billable.getSubscriptions),
            this.store.select(Selectors.billable.getSearchEngines),
            this.store.select(Selectors.billable.getOCR),
            this.store.select(Selectors.billable.getFC),
            this.store.select(Selectors.billable.getNLP)
        ])
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (_a) {
            var subscriptions = _a[0], searchEngines = _a[1], ocrEnabled = _a[2], fcEnabled = _a[3], nlpEnabled = _a[4];
            if (subscriptions.length && searchEngines.length) {
                _this.userSubscriptions = subscriptions;
                _this.searchEngines = searchEngines;
                _this.appSettings.isOCROn = ocrEnabled ? ocrEnabled.display : false;
                _this.appSettings.isFaceCompareOn = fcEnabled ? fcEnabled.display : false;
                _this.appSettings.isNLPon = nlpEnabled ? nlpEnabled.display : false;
                _this.appSettings.usedSearchProvidersNames = _this.prepareSearchProvidersString(searchEngines);
                _this.cdRef.detectChanges();
            }
        });
    };
    /**
     * Retries get billable info again, if failed in auth guard
     * @method retryGetBillable
     */
    VersionCardComponent.prototype.retryGetBillable = function () {
        this.store.dispatch(new Actions.billable.LoadBillable({ quietUpdate: false }));
    };
    return VersionCardComponent;
}());
export { VersionCardComponent };
